import moment from 'moment'
import { INPUTS, FIELD_INPUTS } from '@/entities/fields'

/**
 * Data grid config
 * Doc: https://www.ag-grid.com/javascript-grid-row-models/
 * Examples:
 * - client-side: https://www.ag-grid.com/javascript-grid-client-side-model/
 * - infinite: https://www.ag-grid.com/javascript-grid-infinite-scrolling/
 * - server-side: https://medium.com/@sebastianvcruz/ag-grid-server-side-infinity-scroll-with-paginated-restful-api-and-react-js-b961a847ba7a
 */
const SIDES_DATA = {
    CLIENT_SIDE: '',
    INFINITE: 'infinite',
    SERVER_SIDE: 'serverSide',
}

/**
 * Check if column it is a first
 * @param {Object} - Column grid api
 * @param {Object} - Column object
 */
const isFirstCol = ({ columnApi, column }) => {
    const [first] = columnApi.getAllDisplayedColumns()
    return first === column
}

/**
 * Compare two values changed by field type
 * @param {any} - New value
 * @param {any} - Old value
 * @param {String} - Type of field
 */
const compareValues = (newValue, oldValue, type) => {
    if (FIELD_INPUTS[type] === INPUTS.DATE) {
        const momentNewValue = moment(newValue)
        const momentOldValue = moment(oldValue)
        const differenceBetweenDates = momentNewValue.diff(momentOldValue, 'days')
        return differenceBetweenDates !== 0
    }

    if (FIELD_INPUTS[type] === INPUTS.NUMBER) {
        return !!((oldValue && newValue !== String(oldValue)) || (!oldValue && newValue))
    }

    if (FIELD_INPUTS[type] === INPUTS.SELECT) {
        return String(newValue) !== String(oldValue)
    }

    return newValue !== oldValue
}

/**
 * Drag and drop rows config
 * IMPORTANT:
 * - Works with Client-Side row model only and not with the Infinite, Server-Side or Viewport row models.
 * - Does not work if Pagination is enabled.
 * Doc: https://www.ag-grid.com/javascript-grid-row-dragging/
 */
const GRID_DRAG_AND_DROP_CONFIG = {
    defaultColDef: {
        rowDrag: isFirstCol,
    },
    rowDragManaged: true,
    animateRows: true,
}

/**
 * Map all nodes and return the value of field
 * @param {Object} - Grid api
 * @param {String} - Field key
 */
const getFieldNodes = (gridApi, field = 'key') => {
    const fields = []
    if (gridApi) gridApi.forEachNode(({ data }) => fields.push(data[field]))
    return fields
}

export default {
    sidesData: SIDES_DATA,
    draggableConfig: GRID_DRAG_AND_DROP_CONFIG,
    isFirstCol,
    compareValues,
    getFieldNodes,
}
